import { render, staticRenderFns } from "./payment-info-view.vue?vue&type=template&id=5f131348&scoped=true"
import script from "./payment-info-view.vue?vue&type=script&lang=js"
export * from "./payment-info-view.vue?vue&type=script&lang=js"
import style0 from "./payment-info-view.vue?vue&type=style&index=0&id=5f131348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f131348",
  null
  
)

export default component.exports